export const FeatureFlags = {
  SSO_AUTO_POPULATE: 'ssoAutoPopulate',
  MULTI_CURRENCIES: 'multiCurrencies',
  REDIRECT_WHEN_NO_FLIGHT: 'redirectWhenNoFlight',
  FAVORITE_MEMBERS_SUGGESTION: 'favoriteMembersSuggestion',
  ENABLE_SNAP_SEARCH_MULTIPLE_ROOMS: 'ENABLE_SNAP_SEARCH_MULTIPLE_ROOMS',
  GET_USER_TIER_FROM_LOCAL_STORAGE: 'getUserTierFromLocalStorage',
  ENABLE_BUNDLE_SAVING_TAG_WEB: 'enableBundleSavingTagWeb',
  ENABLE_BUNDLE_SAVING_TAG_APP: 'enableBundleSavingTagApp',
  ENABLE_IMAGE_CAROUSEL_WEB: 'enableImageCarouselWeb',
  ENABLE_IMAGE_CAROUSEL_APP: 'enableImageCarouselApp',
  ENABLE_NEW_CHECKOUT_ENDPOINT: 'enableNewCheckoutEndpoint',
  ENABLE_NEW_FLIGHT_CHANGE_ENDPOINT: 'enableNewFlightChangeEndpoint',
  ENABLE_HOTEL_RECOMMENDATION: 'enableHotelRecommendation',
  ENABLE_HOTEL_NAME_SEARCH_WEB: 'enableHotelNameSearchWeb',
  ENABLE_PRICE_FILTER_WEB: 'enablePriceFilterWeb',
  ENABLE_PRICE_FILTER_APP: 'enablePriceFilterApp',
  ENABLE_PROMOTION_BOX_ELEMENT_WEB: 'enablePromotionBoxElementWeb',
  ENABLE_FIRESTORE_RECOMMENDATION: 'enableFirestoreRecommendation',
  ENABLE_POI_ROOM_SELECT_APP: 'showPoiInRoomSelectApp',
  ENABLE_ROOM_SELECT_NAV_BAR: 'enableRoomSelectNavBar',
  ENABLE_GUEST_REVIEW_OVERVIEW: 'enableGuestReviewOverview',
  ENABLE_GUEST_REVIEW_OVERVIEW_APP: 'enableGuestReviewOverviewMobile',
  ENABLE_GUEST_REVIEW_WEB: 'enableGuestReviewWeb',
  ENABLE_GUEST_REVIEW_MOBILE: 'enableGuestReviewMobile',
  HOTEL_ENABLE_NEW_ROOM_CARD_APP: 'enableNewRoomCardApp',
  ENABLE_COMBO_SAVING_TAG_APP: 'enableComboSavingsTagApp',
  ENABLE_COMBO_SAVING_BUTTONCLICK_APP: 'ComboSavingsbuttonClickApp',
  ENABLE_COMBO_SAVING_TAG_WEB: 'enableComboSavingsTagWeb',
  ENABLE_NEW_SELECT_ROOM_BUTTON_HOTEL_CARD: 'enableSelectRoomButtonHotelCard',
  ENABLE_NEW_ROOM_CARD_WEB: 'enableNewRoomCardWeb',
  ENABLE_CUSTOMIZED_RATE_NAME_WEB: 'enableCustomizedRateNameWeb',
  ENABLE_CUSTOMIZED_RATE_NAME_MOBILE: 'enableCustomizedRateNameMobile',
  ENABLE_ROOM_FILTERS_WEB: 'enableRoomFiltersWeb',
  ENABLE_ROOM_FILTERS_APP: 'enableRoomFiltersApp',
  ENABLE_PROPERTY_FILTER_APP: 'enablePropertyFilterApp',
  ENABLE_PROPERTY_FILTER_WEB: 'enablePropertyFilterWeb',
  HOTEL_SNAP_ENABLE_NEW_DEAL_CTA: 'enableDealCTAApp',
  ENABLE_ROOM_DETAILS_MENU_TAB_APP: 'enableRoomDetailsMenuTabApp',
  ENABLE_MY_TOURISM_TAX: 'enableMYtourismTax',
  ENABLE_SHOW_RECOMMENDATION_HOTEL: 'showRecommendationHotel',
  ENABLE_SNAP_ONE_WAY_APP: 'enableSnapOneWayApp',
  ENABLE_SNAP_TRAVEL_DOCUMENTS_APP: 'enableSNAPTravelDocumentsApp',
  ENABLE_SNAP_TRAVEL_DOCUMENTS_WEB: 'enableSNAPTravelDocumentsWeb',
  ENABLE_ROOM_PAGE_REDESIGNED_APP: 'enableRoomPageRedesignedApp',
  ENABLE_SNAP_CANCELLATION_APP: 'enableSnapCancellationApp',
  ENABLE_SNAP_CANCELLATION_WEB: 'enableSnapCancellationWeb',
  TRAVEL_DOCUMENT_ID_MAX_LENGTH: 'travelDocumentIdMaxLength',
  ENABLE_SNAP_GUEST_RATING_DISELECT_WEB: 'enableSnapGuestRatingDiselectWeb',
  ENABLE_SNAP_GUEST_RATING_DISELECT_APP: 'enableSnapGuestRatingDiselectApp',
  ENABLE_SNAP_COLLECTIONS_EXPERIMENT: 'enableSnapCollectionsExperiment',
  ENABLE_REBRANDING_SNAP_WEB: 'enableRebrandingSnapWeb',
  ENABLE_NEW_SNAP_MAP_HOTEL_CARD: 'enableNewSnapMapHotelCard',
  ENABLE_PAX_AGE_UPDATE_APP: 'enablePaxAgeUpdateApp',
  ENABLE_PAX_AGE_UPDATE_WEB: 'enablePaxAgeUpdateWeb',
  ENABLE_HOTEL_FOMO_MESSAGES_APP: 'hotelFomoMessagesApp',
  ENABLE_HOTEL_BOOKINGS_DONE_FOMO: 'hotelBookingsDoneFomo',
  ENABLE_HOTEL_LAST_ROOM_FOMO: 'hotelLastRoomFomo',
  ENABLE_HOTEL_LAST_ROOM_COUNT_FOMO: 'hotelLastRoomCountFomo',
  ENABLE_HOTEL_FAST_FILLING_FOMO: 'hotelFastFillingFomo',
  ENABLE_SNAP_HOTEL_DISCOUNT_TYPE: 'snapHotelDiscountType',
  ENABLE_SNAP_CHECKOUT_V4: 'enableSnapCheckoutV4',
  ENABLE_ERROR_REVAMP_SNAP: 'enableErrorRevampSnap',
  SHOW_HOTEL_CONTENT_SNAP_WEB: 'showHotelContentSnapWeb',
  SHOW_HOTEL_CONTENT_SNAP_APP: 'showHotelContentSnapApp',
  ENABLE_INSTALLMENT_LISTING_WEB: 'enableInstallmentListingWeb',
  ENABLE_NEW_FLIGHT_CARD: 'enableNewFlightCard',
};

export const HotelFeatureFlags = {
  HOTEL_SSO_AUTO_POPULATE: 'HOTEL_SSO_AUTO_POPULATE',
  ENABLE_HOTEL_SPECIAL_REQUEST: 'ENABLE_HOTEL_SPECIAL_REQUEST',
  HOTEL_SEO_UPDATE_WEB: 'HOTEL_SEO_UPDATE_WEB',
  HOTEL_ENABLE_SEARCH_HEADER: 'HOTEL_ENABLE_SEARCH_HEADER',
  HOTEL_LIST_BATCH_SIZE: 'HOTEL_LIST_BATCH_SIZE',
  HOTEL_IMAGE_GALLERY: 'HOTEL_IMAGE_GALLERY', // v1
  HOTEL_IMAGE_GALLERY_WEB: 'HOTEL_IMAGE_GALLERY_WEB',
  HOTEL_IMAGE_GALLERY_NATIVE: 'HOTEL_IMAGE_GALLERY_NATIVE',
  HOTEL_ENABLE_RE_SEARCH_V2_MOBILE: 'HOTEL_ENABLE_RE_SEARCH_V2_MOBILE',
  HOTEL_ENABLE_RE_SEARCH_V2_WEB: 'HOTEL_ENABLE_RE_SEARCH_V2_WEB',
  HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_WEB:
    'HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_WEB',
  HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_NATIVE:
    'HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_NATIVE',
  HOTEL_ENABLE_NPS_WEB: 'HOTEL_ENABLE_NPS_WEB',
  HOTEL_ENABLE_NPS_MOBILE: 'HOTEL_ENABLE_NPS_MOBILE',
  HOTEL_ENABLE_FOCUS_HOTEL_HIGHLIGHT: 'HOTEL_ENBALE_FOCUS_HOTEL_HIGHLIGHT',
  HOTEL_ENABLE_POI: 'HOTEL_ENABLE_POI',
  HOTEL_ENABLE_PAY_AT_HOTEL_TESTING: 'HOTEL_ENABLE_PAY_AT_HOTEL_TESTING',
  HOTEL_ENABLE_GUEST_DETAILS_PULL: 'HOTEL_ENABLE_GUEST_DETAILS_PULL',
  HOTEL_ENABLE_ROOM_RECOMMENDED: 'HOTEL_ENABLE_ROOM_RECOMMENDED',
  HOTEL_ENABLE_NEW_HOTEL_SEARCH_WIDGET: 'HOTEL_ENABLE_NEW_HOTEL_SEARCH_WIDGET',
  HOTEL_ENABLE_TEST_PRICE_CHANGED: 'HOTEL_ENABLE_TEST_PRICE_CHANGED',
  HOTEL_ENBALE_CHILD_AGE_INPUT: 'HOTEL_ENBALE_CHILD_AGE_INPUT',
  HOTEL_ENABLE_DISCOUNT_POPUP: 'HOTEL_ENABLE_DISCOUNT_POPUP',
  HOTEL_ENABLE_AMENITIES_FILTER: 'HOTEL_ENABLE_AMENITIES_FILTER',
  HOTEL_ENABLE_NEW_HOTEL_CARD: 'HOTEL_ENABLE_NEW_HOTEL_CARD',
  HOTEL_ENABLE_BIGPOINTS_TOGGLE: 'HOTEL_ENABLE_BIGPOINTS_TOGGLE',
  HOTEL_ENABLE_HOTEL_CLASS_FILTER_WEB: 'HOTEL_ENABLE_HOTEL_CLASS_FILTER_WEB',
  HOTEL_SORT_BY_V2_WEB: 'HOTEL_SORT_BY_V2_WEB',
  HOTEL_ENABLE_HOTEL_CLASS_FILTER_APP: 'HOTEL_ENABLE_HOTEL_CLASS_FILTER_APP',
  HOTEL_ENABLE_SHOW_MAP_ENTRY_POINT: 'HOTEL_ENABLE_SHOW_MAP_ENTRY_POINT',
  HOTEL_MANDATE_LOGIN_WEB: 'HOTEL_MANDATE_LOGIN_WEB',
  HOTEL_ENABLE_PRICE_FILTER: 'HOTEL_ENABLE_PRICE_FILTER',
  HOTEL_ENABLE_PRICE_FILTER_APP: 'HOTEL_ENABLE_PRICE_FILTER_APP',
  HOTEL_ENABLE_NEIGHBOURHOOD_FILTER: 'HOTEL_ENABLE_NEIGHBOURHOOD_FILTER',
  HOTEL_ENABLE_HOTEL_LISTING_FEEDBACK: 'HOTEL_ENABLE_HOTEL_LISTING_FEEDBACK',
  HOTEL_ENABLE_ROOM_SELECT_FEEDBACK: 'HOTEL_ENABLE_ROOM_SELECT_FEEDBACK',
  HOTEL_ENABLE_GUEST_DETAILS_FEEDBACK: 'HOTEL_ENABLE_GUEST_DETAILS_FEEDBACK',
  HOTEL_ENABLE_MAPS_FEEDBACK: 'HOTEL_ENABLE_MAPS_FEEDBACK',
  HOTEL_ENABLE_PAYMENT_CANCELLATION_POLICY_FILTER:
    'HOTEL_ENABLE_PAYMENT_CANCELLATION_POLICY_FILTER',
  HOTEL_ENABLE_GUEST_REVIEW_OVERVIEW: 'HOTEL_ENABLE_GUEST_REVIEW_OVERVIEW',
  HOTEL_ENABLE_GUEST_REVIEW_OVERVIEW_APP:
    'HOTEL_ENABLE_GUEST_REVIEW_OVERVIEW_APP',
  HOTEL_ENABLE_GUEST_REVIEW_WEB: 'HOTEL_ENABLE_GUEST_REVIEW_WEB',
  HOTEL_ENABLE_GUEST_REVIEW_MOBILE: 'HOTEL_ENABLE_GUEST_REVIEW_MOBILE',
  HOTEL_ENABLE_NEW_SORT_BY_MOBILE: 'HOTEL_ENABLE_NEW_SORT_BY_MOBILE',
  ENABLE_SORT_FILTER_NEW_UI: 'ENABLE_SORT_FILTER_NEW_UI',
  HOTEL_ENABLE_PAYMENT_CANCELLATION_POLICY_FILTER_APP:
    'HOTEL_ENABLE_PAYMENT_CANCELLATION_POLICY_FILTER_APP',
  HOTEL_ENABLE_DISCOUNT_SUPERFEST: 'HOTEL_ENABLE_DISCOUNT_SUPERFEST',
  HOTEL_ENABLE_NEW_ROOM_CARD_APP: 'HOTEL_ENABLE_NEW_ROOM_CARD_APP',
  HOTEL_ENABLE_NEW_ROOM_CARD_WEB: 'HOTEL_ENABLE_NEW_ROOM_CARD_WEB',
  HOTEL_ENABLE_CUSTOMIZED_RATE_NAME_WEB:
    'HOTEL_ENABLE_CUSTOMIZED_RATE_NAME_WEB',
  HOTEL_ENABLE_CUSTOMIZED_RATE_NAME_APP:
    'HOTEL_ENABLE_CUSTOMIZED_RATE_NAME_APP',
  HOTEL_ENABLE_VOUCHER_BANNER_WEB: 'HOTEL_ENABLE_VOUCHER_BANNER_WEB',
  HOTEL_ENABLE_ROOM_FILTERS_WEB: 'HOTEL_ENABLE_ROOM_FILTERS_WEB',
  HOTEL_ENABLE_ROOM_FILTERS_APP: 'HOTEL_ENABLE_ROOM_FILTERS_APP',
  HOTEL_ENABLE_PROPERTY_TYPES_FILTER: 'HOTEL_ENABLE_PROPERTY_TYPES_FILTER',
  HOTEL_SNAP_ENABLE_NEW_DEAL_CTA: 'HOTEL_SNAP_ENABLE_NEW_DEAL_CTA',
  HOTEL_PROPERTY_TYPES_FILTER_WEB: 'HOTEL_PROPERTY_TYPES_FILTER_WEB',
  HOTEL_SA_ENABLE_NEW_DEAL_CTA: 'HOTEL_SA_ENABLE_NEW_DEAL_CTA',
  HOTEL_DEAL_OF_THE_DAY_TIME: 'HOTEL_DEAL_OF_THE_DAY_TIME',
  HOTEL_LIST_GOOGLE_ADS_SIZE: 'HOTEL_LIST_GOOGLE_ADS_SIZE',
  ENABLE_GOOGLEADS_LISTING_WEB: 'ENABLE_GOOGLEADS_LISTING_WEB',
  ENABLE_INDEX_OF_ADS_LSTINGPAGE: 'ENABLE_INDEX_OF_ADS_LSTINGPAGE',
  HOTEL_ENABLE_DEAL_OF_THE_DAY: 'HOTEL_ENABLE_DEAL_OF_THE_DAY',
  HOTEL_ENABLE_DEAL_OF_THE_DAY_WEB: 'HOTEL_ENABLE_DEAL_OF_THE_DAY_WEB',
  HOTEL_ENABLE_PROMOTION_FILTER_APP: 'HOTEL_ENABLE_PROMOTION_FILTER_APP',
  HOTEL_ENABLE_PROMOTION_FILTER_WEB: 'HOTEL_ENABLE_PROMOTION_FILTER_WEB',
  ENABLE_HOTEL_NOT_AVAILABLE_WEB: 'ENABLE_HOTEL_NOT_AVAILABLE_WEB',
  ENABLE_HOTEL_NOT_AVAILABLE_APP: 'ENABLE_HOTEL_NOT_AVAILABLE_APP',
  HOTEL_ENABLE_ROOM_DETAILS_MENU_TAB_APP:
    'HOTEL_ENABLE_ROOM_DETAILS_MENU_TAB_APP',
  HOTEL_ENABLE_MY_TOURISM_TAX_WEB: 'HOTEL_ENABLE_MY_TOURISM_TAX_WEB',
  HOTEL_ENABLE_MY_TOURISM_TAX_APP: 'HOTEL_ENABLE_MY_TOURISM_TAX_APP',
  ENABLE_SHOW_RECOMMENDATION_HOTEL: 'ENABLE_SHOW_RECOMMENDATION_HOTEL',
  SHOW_COMBO_SAVINGS_APP: 'SHOW_COMBO_SAVINGS_APP',
  ENABLE_REARRANGE_FILTER_SECTION_APP: 'ENABLE_REARRANGE_FILTER_SECTION_APP',
  SHOW_PROMOTION_FILTER_CHECKBOX_WEB: 'SHOW_PROMOTION_FILTER_CHECKBOX_WEB',
  HOTEL_ENABLE_ROOM_PAGE_REDESIGNED_APP:
    'HOTEL_ENABLE_ROOM_PAGE_REDESIGNED_APP',
  HOTEL_ROOM_DETAILS_DATE_SELECTION_APP:
    'HOTEL_ROOM_DETAILS_DATE_SELECTION_APP',
  ENABLE_NEW_FILTER_TOP_VIEW_APP: 'ENABLE_NEW_FILTER_TOP_VIEW_APP',
  ENABLE_FILTER_PLACEMENT_WEB: 'ENABLE_FILTER_PLACEMENT_WEB',
  ENABLE_SCROLLUP_BUTTON: 'ENABLE_SCROLLUP_BUTTON',
  ENABLE_FILTER_REARRANGEMENT_WEB: 'ENABLE_FILTER_REARRANGEMENT_WEB',
  ENABLE_EXPIRED_POPUP_MESSAGE: 'ENABLE_EXPIRED_POPUP_MESSAGE',
  ENABLE_EXPIRED_POPUP_MESSAGE_WEB: 'ENABLE_EXPIRED_POPUP_MESSAGE_WEB',
  ENABLE_SELECT_ROOM_LABEL_HOTEL_WEB: 'ENABLE_SELECT_ROOM_LABEL_HOTEL_WEB',
  ENABLE_DROPOUT_PROMO_CODE: 'ENABLE_DROPOUT_PROMO_CODE',
  HOTEL_DROPOUT_PROMO_CODE: 'HOTEL_DROPOUT_PROMO_CODE',
  ENABLE_BIGPAY_CARD_PROMO_WEB: 'ENABLE_BIGPAY_CARD_PROMO_WEB',
  ENABLE_ROOM_CARD_COLUMNISED_APP: 'ENABLE_ROOM_CARD_COLUMNISED_APP',
  ENABLE_FAVOURITES_HOTEL_MOBILE: 'ENABLE_FAVOURITES_HOTEL_MOBILE',
  ENABLE_HOTEL_GUEST_RATING_DISELECT_WEB:
    'ENABLE_HOTEL_GUEST_RATING_DISELECT_WEB',
  ENABLE_HOTEL_GUEST_RATING_DISELECT_APP:
    'ENABLE_HOTEL_GUEST_RATING_DISELECT_APP',
  ENABLE_DISTANCE_FROM_CITY_CENTER_WEB: 'ENABLE_DISTANCE_FROM_CITY_CENTER_WEB',
  ENABLE_DISTANCE_FROM_CITY_CENTER_APP: 'ENABLE_DISTANCE_FROM_CITY_CENTER_APP',
  ENABLE_TYPESENSE_AB_TESTING: 'ENABLE_TYPESENSE_AB_TESTING',
  HOTEL_ENABLE_SOLD_OUT: 'HOTEL_ENABLE_SOLD_OUT',
  ENABLE_PAYMENT_CARD_MESSAGE: 'ENABLE_PAYMENT_CARD_MESSAGE',
  ENABLE_SWIPABLE_CAROUSEL: 'ENABLE_SWIPABLE_CAROUSEL',
  ENABLE_GOOGLE_ADS_WEB: 'ENABLE_GOOGLE_ADS_WEB',
  HOTEL_BANNER_IMAGE_APP_AB_TESTING: 'HOTEL_BANNER_IMAGE_APP_AB_TESTING',
  HOTEL_ENABLE_TRIPADVISOR_RATING: 'HOTEL_ENABLE_TRIPADVISOR_RATING',
  HOTEL_ENABLE_SHOW_MAP_ENTRY_POINT_APP:
    'HOTEL_ENABLE_SHOW_MAP_ENTRY_POINT_APP',
  HOTEL_ENABLE_GOOGLEADS_LISTING_APP: 'HOTEL_ENABLE_GOOGLEADS_LISTING_APP',
  HOTEL_GOOGLEADS_LISTING_INDEX_APP: 'HOTEL_GOOGLEADS_LISTING_INDEX_APP',
  HOTEL_COLLECTIONS_EXPERIMENT_ENABLED: 'HOTEL_COLLECTIONS_EXPERIMENT_ENABLED',
  ENABLE_GOOGLE_ADS_BOOKING_DETAILS_WEB:
    'ENABLE_GOOGLE_ADS_BOOKING_DETAILS_WEB',
  HOTEL_PROMO_CODE_ENABLED_APP: 'HOTEL_PROMO_CODE_ENABLED_APP',
  HOTEL_PROMO_BANNER_ENABLED_APP: 'HOTEL_PROMO_BANNER_ENABLED_APP',
  DESTINATION_FOR_AB_TESTING: 'DESTINATION_FOR_AB_TESTING',
  HOTEL_PROMO_CODE_ENABLED_WEB: 'HOTEL_PROMO_CODE_ENABLED_WEB',
  HOTEL_FOMO_MESSAGES_APP: 'HOTEL_FOMO_MESSAGES_APP',
  HOTEL_FAST_FILLING_FOMO: 'HOTEL_FAST_FILLING_FOMO',
  HOTEL_BOOKINGS_DONE_FOMO: 'HOTEL_BOOKINGS_DONE_FOMO',
  HOTEL_LAST_ROOM_FOMO: 'HOTEL_LAST_ROOM_FOMO',
  HOTEL_LAST_ROOM_COUNT_FOMO: 'HOTEL_LAST_ROOM_COUNT_FOMO',
  HOTEL_PRICE_DROP_FOMO: 'HOTEL_PRICE_DROP_FOMO',
  HOTEL_ENABLE_SOLD_OUT_WEB: 'HOTEL_ENABLE_SOLD_OUT_WEB',
  HOTEL_PROMO_BANNER_ENABLED_WEB: 'HOTEL_PROMO_BANNER_ENABLED_WEB',
  HOTEL_FOMO_MESSAGES_WEB: 'HOTEL_FOMO_MESSAGES_WEB',
  HOTEL_BOGO_PROMO_APP: 'HOTEL_BOGO_PROMO_APP',
  HOTEL_BOGO_DISCOUNT_ID: 'HOTEL_BOGO_DISCOUNT_ID',
  HOTEL_BOGO_PROMO_WEB: 'HOTEL_BOGO_PROMO_WEB',
  HOTEL_GOOGLEMAPS_COLORED_WEB: 'HOTEL_GOOGLEMAPS_COLORED_WEB',
  HOTEL_GOOGLEMAPS_COLORED_APP: 'HOTEL_GOOGLEMAPS_COLORED_APP',
  HOTEL_PAYNOW_FILTER_APP: 'HOTEL_PAYNOW_FILTER_APP',
  HOTEL_DROPOUT_PROMO_COUNTRY_SPECIFIC: 'HOTEL_DROPOUT_PROMO_COUNTRY_SPECIFIC',
  HOTEL_LISTING_PROMO_CODE_IDS: 'HOTEL_LISTING_PROMO_CODE_IDS',
  HOTEL_PAYNOW_FILTER_LISTING_APP: 'HOTEL_PAYNOW_FILTER_LISTING_APP',
  HOTEL_PAYNOW_FILTER_LISTING_WEB: 'HOTEL_PAYNOW_FILTER_LISTING_WEB',
  HOTEL_PAYNOW_PROMO_CODE_IDS: 'HOTEL_PAYNOW_PROMO_CODE_IDS',
  HOTEL_PAYNOW_TAG_LISTING_APP: 'HOTEL_PAYNOW_TAG_LISTING_APP',
  HOTEL_PAYNOW_PROMO_CODE_IDS_WEB: 'HOTEL_PAYNOW_PROMO_CODE_IDS_WEB',
  HOTEL_PAYNOW_TAG_LISTING_WEB: 'HOTEL_PAYNOW_TAG_LISTING_WEB',
  HOTEL_DEFAULT_PAY_NOW_SELECTION_WEB: 'HOTEL_DEFAULT_PAY_NOW_SELECTION_WEB',
  ENABLE_SORT_FILTER_MAP_VIEW_APP: 'ENABLE_SORT_FILTER_MAP_VIEW_APP',
  ENABLE_MAP_VIEW_SEARCH_HEADER_APP: 'ENABLE_MAP_VIEW_SEARCH_HEADER_APP',
  ENABLE_MULTIPLE_CURRENCY_MAP_HEADER_APP:
    'ENABLE_MULTIPLE_CURRENCY_MAP_HEADER_APP',
  ENABLE_NEW_LISTING_HOTEL_CARD: 'ENABLE_NEW_LISTING_HOTEL_CARD',
  ENABLE_NEW_MAP_HOTEL_CARD: 'ENABLE_NEW_MAP_HOTEL_CARD',
  ENABLE_REBRANDING_HOTEL_APP: 'ENABLE_REBRANDING_HOTEL_APP',
  ENABLE_REBRANDING_HOTEL_WEB: 'ENABLE_REBRANDING_HOTEL_WEB',
  HOTEL_SMARTFILL_API_AB_TESTING: 'HOTEL_SMARTFILL_API_AB_TESTING',
  HOTEL_PAYLATER_TAG_LISTING_APP: 'HOTEL_PAYLATER_TAG_LISTING_APP',
  HOTEL_PAYLATER_TAG_LISTING_WEB: 'HOTEL_PAYLATER_TAG_LISTING_WEB',
  ENABLE_USER_SUBSCRIPTION_APP: 'ENABLE_USER_SUBSCRIPTION_APP',
  ENABLE_USER_SUBSCRIPTION_WEB: 'ENABLE_USER_SUBSCRIPTION_WEB',
  ENABLE_CROSS_SELL_BANNER_APP: 'ENABLE_CROSS_SELL_BANNER_APP',
  ENABLE_CROSS_SELL_BANNER_WEB: 'ENABLE_CROSS_SELL_BANNER_WEB',
  FLYER_DISCOUNT_BANNER_IMG_APP: 'FLYER_DISCOUNT_BANNER_IMG_APP',
  FLYER_DISCOUNT_BANNER_IMG_WEB: 'FLYER_DISCOUNT_BANNER_IMG_WEB',
  CROSS_SELL_DISCOUNT_PERCENTAGE: 'CROSS_SELL_DISCOUNT_PERCENTAGE',
  CROSS_SELL_PROMO_CODE: 'CROSS_SELL_PROMO_CODE',
  CROSS_SELL_PERCENT_VALUE: 'CROSS_SELL_PERCENT_VALUE',
  EXCLUSIVE_DEAL_TYPE_ID: 'EXCLUSIVE_DEAL_TYPE_ID',
  BOGO_DISCOUNT_BANNER_IMG_APP: 'BOGO_DISCOUNT_BANNER_IMG_APP',
  BOGO_DISCOUNT_BANNER_IMG_WEB: 'BOGO_DISCOUNT_BANNER_IMG_WEB',
  BOGO_DISCOUNT_PERCENTAGE: 'BOGO_DISCOUNT_PERCENTAGE',
  BOGO_PROMO_CODE: 'BOGO_PROMO_CODE',
  BOGO_PERCENT_VALUE: 'BOGO_PERCENT_VALUE',
  BOGO_BANNER_LABEL_TEXT: 'BOGO_BANNER_LABEL_TEXT',
  RM9_DISCOUNT_BANNER_IMG_APP: 'RM9_DISCOUNT_BANNER_IMG_APP',
  RM9_DISCOUNT_BANNER_IMG_WEB: 'RM9_DISCOUNT_BANNER_IMG_WEB',
  RM9_DISCOUNT_PERCENTAGE: 'RM9_DISCOUNT_PERCENTAGE',
  RM9_PROMO_CODE: 'RM9_PROMO_CODE',
  RM9_PERCENT_VALUE: 'RM9_PERCENT_VALUE',
  RM9_BANNER_LABEL_TEXT: 'RM9_BANNER_LABEL_TEXT',
  HOTEL_ENABLE_FLYER_DISCOUNT_WEB: 'HOTEL_ENABLE_FLYER_DISCOUNT_WEB',
  ENABLE_BOGO_TOGGLE_BANNER_APP: 'ENABLE_BOGO_TOGGLE_BANNER_APP',
  ENABLE_BOGO_TOGGLE_BANNER_WEB: 'ENABLE_BOGO_TOGGLE_BANNER_WEB',
  PROMO_DISCOUNT_LOCATIONS: 'PROMO_DISCOUNT_LOCATIONS',
  ENABLE_HOTEL_CARD_RM9_BUTTON: 'ENABLE_HOTEL_CARD_RM9_BUTTON',
  ENABLE_HOTEL_CARD_RM9_BUTTON_WEB: 'ENABLE_HOTEL_CARD_RM9_BUTTON_WEB',
  ENABLE_IDR_VND_SAVINGLABEL_SORTED: 'ENABLE_IDR_VND_SAVINGLABEL_SORTED',
  ENABLE_ROUND_SAVINGLABEL_CURRENCY: 'ENABLE_ROUND_SAVINGLABEL_CURRENCY',
  ENABLE_EINVOICE_CONFIRMATION_PAGE: 'ENABLE_EINVOICE_CONFIRMATION_PAGE',
  ENABLE_EINVOICE_CONFIRMATION_PAGE_MOBILE:
    'ENABLE_EINVOICE_CONFIRMATION_PAGE_MOBILE',
  ENABLE_PRICEBUCKETS_FROM_CONFIG_APP: 'ENABLE_PRICEBUCKETS_FROM_CONFIG_APP',
  ENABLE_PRICEBUCKETS_FROM_CONFIG_WEB: 'ENABLE_PRICEBUCKETS_FROM_CONFIG_WEB',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_MYR:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_MYR',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_AUD:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_AUD',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_CNY:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_CNY',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_EUR:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_EUR',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_GBP:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_GBP',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_HKD:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_HKD',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_JPY:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_JPY',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_NZD:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_NZD',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_PHP:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_PHP',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_SGD:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_SGD',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_THB:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_THB',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_USD:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_USD',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_BDT:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_BDT',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_BND:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_BND',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_INR:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_INR',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_IDR:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_IDR',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_KRW:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_KRW',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_MOP:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_MOP',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_TWD:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_TWD',
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_VND:
    'PER_PERSION_PRICE_FILTER_BUCKETS_FOR_VND',
  ENABLE_LEMON_ADT_DUTYTRAVEL: 'ENABLE_LEMON_ADT_DUTYTRAVEL',
  ENABLE_ORACLE_ID_FIELD: 'ENABLE_ORACLE_ID_FIELD',
  ENABLE_PRE_CHECKOUT_CALL_APP: 'ENABLE_PRE_CHECKOUT_CALL_APP',
  ENABLE_PRE_CHECKOUT_CALL_WEB: 'ENABLE_PRE_CHECKOUT_CALL_WEB',
  ENABLE_PRE_CHECKOUT_CALL_GUEST_DETAILS_PAGE_WEB:
    'ENABLE_PRE_CHECKOUT_CALL_GUEST_DETAILS_PAGE_WEB',
  ENABLE_PRE_CHECKOUT_CALL_GUEST_DETAILS_PAGE_APP:
    'ENABLE_PRE_CHECKOUT_CALL_GUEST_DETAILS_PAGE_APP',
  ENABLE_PRICE_MESSAGE_BOOKING_DETAILS: 'ENABLE_PRICE_MESSAGE_BOOKING_DETAILS',
  ENABLE_NEW_IP_URL: 'ENABLE_NEW_IP_URL',
  ENABLE_ROOM_DEDUPE_EXPERIMENT: 'ENABLE_ROOM_DEDUPE_EXPERIMENT',
  ENABLE_NEW_IP_URL_WEB: 'ENABLE_NEW_IP_URL_WEB',
  ENABLE_SEO_DATA: 'ENABLE_SEO_DATA',
  SHOW_HOTEL_CONTENT_HOTEL_APP: 'SHOW_HOTEL_CONTENT_HOTEL_APP',
  SHOW_HOTEL_CONTENT_HOTEL_WEB: 'SHOW_HOTEL_CONTENT_HOTEL_WEB',
  ENABLE_INSTALLMENT_APP: 'ENABLE_INSTALLMENT_APP',
  ENABLE_BLOCKED_RATES_APP: 'ENABLE_BLOCKED_RATES_APP',
  ENABLE_BLOCKED_RATES_WEB: 'ENABLE_BLOCKED_RATES_WEB',
  ENABLE_REMOVE_BACK_NAVIGATION_APP: 'ENABLE_REMOVE_BACK_NAVIGATION_APP',
  ENABLE_REMOVE_BACK_NAVIGATION_WEB: 'ENABLE_REMOVE_BACK_NAVIGATION_WEB',
  ENABLE_SENDING_MFT_PARAMETER: 'ENABLE_SENDING_MFT_PARAMETER',
  ENABLE_EXTRA_ROOM_AMENITIES: 'ENABLE_EXTRA_ROOM_AMENITIES',
  SUPPORTED_CURRENCIES: 'SUPPORTED_CURRENCIES',
  ENABLE_EXTRA_ROOM_AMENITIES_WEB: 'ENABLE_EXTRA_ROOM_AMENITIES_WEB',
  SEND_REFRESH_TOKEN_IN_BFFAPIS: 'SEND_REFRESH_TOKEN_IN_BFFAPIS',
};
